const Base = {
  "projectorTypes": {
    "Standard-Throw": {
      "Dark": {
        

        "CineWhite": {
          "r169": {
            "Black": {
              "92": [{ "30": ["43533159301386"] }],
              "100": [{ "30": ["43533159334154"] }],
              "110": [{ "30": ["43533159366922"] }],
              "120": [{ "30": ["43533159399690"] }],
              "135": [{ "30": ["43533159432458"] }],
              "150": [{ "30": ["43533159465226"] }]
            }
          },
          "r1610":{
            "Black": {
              "109": [{ "30": ["43533147439370"] }],
              "128": [{ "30": ["43533147472138"] }],
              "142": [{ "30": ["43533147504906"] }],
              "155": [{ "30": ["43533147537674"] }]
          }
        },
          "r219":{
              "Black": {
              "85": [{ "30": ["43533147570442"] }],
              "96": [{ "30": ["43533147603210"] }],
              "103": [{ "30": ["43533147635978"] }],
              "115": [{ "30": ["43533147668746"] }],
              "125": [{ "30": ["43533147701514"] }],
              "138": [{ "30": ["43533147734282"] }],
              "158": [{ "30": ["43533147767050"] }],
              "166": [{ "30": ["43533147799818"] }]
             
            }
          },
          "r43":{
     "Black": {
              "84": [{ "30": ["43533146849546"] }],
              "100": [{ "30": ["43533146882314"] }],
              "120": [{ "30": ["43533146915082"] }],
              "135": [{ "30": ["43533146947850"] }],
              "150": [{ "30": ["43533146980618"] }],
              "180": [{ "30": ["43533147013386"] }],
              "200": [{ "30": ["43533147046154"] }]
             
            }
          }
        },

             "CineWhite-Acoustic": {
          "r169": {
            "Black": {
              "100": [{ "30": ["44793972916490"] }],
              "120": [{ "30": ["44793978585354"] }],
              "135": [{ "30": ["44794005815562"] }],
              "150": [{ "30": ["44794016792842"] }]
           
            }
          },
          "r219":{
            "Black": {
              "125": [{ "30": ["44793986908426"] }],
              "138": [{ "30": ["44794009288970"] }],
              "158": [{ "30": ["44794020364554"] }],
              "166": [{ "30": ["44794035994890"] }]
          }
        }},

        "CineGrey": {
          "r169": {
            "Black": {
              "84": [{ "30": ["43533147865354"] }],
              "92": [{ "30": ["43533147898122"] }],
              "100": [{ "30": ["43533147930890"] }],
              "110": [{ "30": ["43533147963658"] }],
              "120": [{ "30": ["43533147996426"] }],
              "135": [{ "30": ["43533148029194"] }],
              "150": [{ "30": ["43533148061962"] }],
              "165": [{ "30": ["43533147341066"] }],
              "180": [{ "30": ["43533148127498"] }],
              "200": [{ "30": ["43533148160266"] }]
            }
          }
        }
          
          
        
      },
      "Bright": {
     "CineGrey": {
          "r169": {
            "Black": {
              "84": [{ "30": ["43533147865354"] }],
              "92": [{ "30": ["43533147898122"] }],
              "100": [{ "30": ["43533147930890"] }],
              "110": [{ "30": ["43533147963658"] }],
              "120": [{ "30": ["43533147996426"] }],
              "135": [{ "30": ["43533148029194"] }],
              "150": [{ "30": ["43533148061962"] }],
              "165": [{ "30": ["43533147341066"] }],
              "180": [{ "30": ["43533148127498"] }],
              "200": [{ "30": ["43533148160266"] }]
            }
          }
        }


      },
           "CineWhite-Acoustic": {
          "r169": {
            "Black": {
              "100": [{ "30": ["44793972916490"] }],
              "120": [{ "30": ["44793978585354"] }],
              "135": [{ "30": ["44794005815562"] }],
              "150": [{ "30": ["44794016792842"] }]
           
            }
          },
          "r219":{
            "Black": {
              "125": [{ "30": ["44793986908426"] }],
              "138": [{ "30": ["44794009288970"] }],
              "158": [{ "30": ["44794020364554"] }],
              "166": [{ "30": ["44794035994890"] }]
          }
        }}
    },

    "Short-Throw":{
      "Dark":{
        "CineWhite": {
          "r169": {
            "Black": {
              "92": [{ "30": ["43533159301386"] }],
              "100": [{ "30": ["43533159334154"] }],
              "110": [{ "30": ["43533159366922"] }],
              "120": [{ "30": ["43533159399690"] }],
              "135": [{ "30": ["43533159432458"] }],
              "150": [{ "30": ["43533159465226"] }]
            }
          },
          "r1610":{
            "Black": {
              "109": [{ "30": ["43533147439370"] }],
              "128": [{ "30": ["43533147472138"] }],
              "142": [{ "30": ["43533147504906"] }],
              "155": [{ "30": ["43533147537674"] }]
          }
        },
          "r219":{
              "Black": {
              "85": [{ "30": ["43533147570442"] }],
              "96": [{ "30": ["43533147603210"] }],
              "103": [{ "30": ["43533147635978"] }],
              "115": [{ "30": ["43533147668746"] }],
              "125": [{ "30": ["43533147701514"] }],
              "138": [{ "30": ["43533147734282"] }],
              "158": [{ "30": ["43533147767050"] }],
              "166": [{ "30": ["43533147799818"] }]
             
            }
          },
          "r43":{
     "Black": {
              "84": [{ "30": ["43533146849546"] }],
              "100": [{ "30": ["43533146882314"] }],
              "120": [{ "30": ["43533146915082"] }],
              "135": [{ "30": ["43533146947850"] }],
              "150": [{ "30": ["43533146980618"] }],
              "180": [{ "30": ["43533147013386"] }],
              "200": [{ "30": ["43533147046154"] }]
             
            }
          }
        },
         "CineWhite-Acoustic": {
          "r169": {
            "Black": {
              "100": [{ "30": ["44793972916490"] }],
              "120": [{ "30": ["44793978585354"] }],
              "135": [{ "30": ["44794005815562"] }],
              "150": [{ "30": ["44794016792842"] }]
           
            }
          },
          "r219":{
            "Black": {
              "125": [{ "30": ["44793986908426"] }],
              "138": [{ "30": ["44794009288970"] }],
              "158": [{ "30": ["44794020364554"] }],
              "166": [{ "30": ["44794035994890"] }]
          }
        }}

      },
      
      "Bright":{
           "CineWhite-Acoustic": {
          "r169": {
            "Black": {
              "100": [{ "30": ["44793972916490"] }],
              "120": [{ "30": ["44793978585354"] }],
              "135": [{ "30": ["44794005815562"] }],
              "150": [{ "30": ["44794016792842"] }]
           
            }
          },
          "r219":{
            "Black": {
              "125": [{ "30": ["44793986908426"] }],
              "138": [{ "30": ["44794009288970"] }],
              "158": [{ "30": ["44794020364554"] }],
              "166": [{ "30": ["44794035994890"] }]
          }
        }}
      }
    }
  }
};
  
var selection={
    "Beamer":'Standard-Throw',
    "Ambience":'Dark',
    "Material":'CineWhite',
    "Aspect":'r169',
    "CaseColor":'Black',
    "Size":100,
    "TopDrop":30,
    "ProdVariant":"43533159334154",
}


const r169 = document.getElementById("r169");
const r1610 = document.getElementById("r1610");
const r219 = document.getElementById("r219");
const r43 = document.getElementById("r43");


/*
document.getElementById('testAvCall').addEventListener("click", function() {
  // Hier kommt die Funktion, die beim Klick ausgeführt wird
  var testAr = Object.keys(Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor]);
  // console.log(testAr);
  var testqueste = Object.keys(Base[selection.Beamer]?.[selection.Ambiance]?.[selection.Material]?.[selection.Aspect]?.[selection.CaseColor] || {});
  // console.log(testqueste);
});
*/

function showMip(){
  return Base[selection.Beamer]?.[selection.Ambiance]?.[selection.Material]?.[selection.Aspect]?.[selection.CaseColor] || {};
}


  function selectBeamer(){
    selection.Beamer= $(this).attr("id");
   //// console.log(selection.Beamer);
  }

  /*
const CLR = document.getElementById("CLR");
const AcousticPro = document.getElementById("AcousticPro");
const MaxWhite = document.getElementById("MaxWhite");
const Cinegrey = document.getElementById("Cinegrey");
*/


var avMaterials;

document.getElementById("Bright").addEventListener("click",setAmbiance);
document.getElementById("Dark").addEventListener("click",setAmbiance);

//document.getElementById("resetFilter").addEventListener("click",resetFilter);

/*
function resetFilter(){
  CLR.style.display="inline-flex"
  AcousticPro.style.display="inline-flex"
  MaxWhite.style.display="inline-flex"
  Cinegrey.style.display="inline-flex"
} */

document.querySelector('.model-div').addEventListener('wheel', function(event) {
    event.preventDefault();
}, { passive: false });

function setAmbiance(){
  selection.Ambience= $(this).attr("id");
  getMaterials();
} 

const buttons = [ "CineWhite","CineWhite-Acoustic","CineGrey"];
const ratio = {r169 ,r1610,r219,r43};



function getMaterials(){
    

    //avMaterials = Object.keys(Base.projectorTypes[selection["Beamer"]][selection["Ambience"]]);

     avMaterials = Object.keys(
    Base.projectorTypes[selection["Beamer"]]?.[selection["Ambience"]] ?? {}
);

const copylist = Base.projectorTypes[selection["Beamer"]]?.[selection["Ambience"]] ?? {};


if(avMaterials.length===0){
 
   document.getElementById("sizesmatdiv").style.display="none";
   document.getElementById("matNotice").style.display="flex";
}else{
 document.getElementById("sizesmatdiv").style.display="block";
   document.getElementById("matNotice").style.display="none";
    hideUI();

    // Alle verfügbaren Materialien angeben!
   
// Schleife durch die verfügbaren Materialien
for (const button of buttons) {
  if (avMaterials.includes(button)) {
    const el = document.getElementById(button);
    if (el) {
      el.style.display = "inline-flex"; // Anzeigen
    }
  }
} 
}


 const result = [];
console.log(copylist);
    // Loop über die obersten Materialien wie CineGrey, CineWhite

 for (const matName in copylist) {
    const mat = copylist[matName];
    
    // Prüfen, ob das Material den gewünschten inneren Key enthält
    if (Object.keys(mat).includes(selection.Aspect)) {
        result.push(matName.toString()); // Oberen Key hinzufügen
    }
}

/*
  $('.buttonMat').prop('disabled', true).css({
    "background-color": "grey",
    "cursor": "not-allowed"
});*/

console.log(result)



      $(".buttonMat").prop('disabled', true).css({
     "background-color": "grey",
    "cursor": "not-allowed"
      }) ;


for (const value of result) {
    const str = value.toString();
    console.log(str); // "CineGrey", "CineWhite"
    $("#" + str).prop('disabled', false).css({
    "background-color": "white",
    "cursor": "pointer"
});
} 


    //console.log(typeof result[0]);


}

/*
function getMaterials2() {
    const ambience = Base.projectorTypes[selection["Beamer"]]?.[selection["Ambience"]] ?? {};
    const result = [];

    // Loop über die obersten Materialien wie CineGrey, CineWhite
    for (const matName in ambience) {
        const mat = ambience[matName];
        // Loop über die inneren Keys wie r169, r219, etc.
        for (const key of Object.keys(mat)) {
            if (key === selection.Aspect) {
                result.push(key);
            }
        }
    }

    return result;
}*/

var avRatios


function getRatios(){

  console.log("RATIOS");
 avRatios = Object.keys(Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material]);
  console.log(avRatios);
  //// console.log(avRatios);

  r169.style.display="none";
 

  for (const key in ratio) {
   // // console.log(key);
   // // console.log();
    if (avRatios.includes(key)) {
      
        ratio[key].style.display = ""; // Anzeigen
    }else{
      ratio[key].style.display = "none"; 
    }
}
}





function hideUI(){
 document.querySelectorAll(".buttonMat").forEach(btn => {
  btn.style.display = "none";
});
}



var  formData ={
  'items': [ {
    'id': 43533159334154,
    'quantity': 1
     
    } ]
};
document.getElementById("addCart").addEventListener("click", addItems1);


function addItems1() {
    //// console.log("additem " + selection.ProdVariant );
  formData.items[0].id=selection.ProdVariant;
    //// console.log("formData: "+ JSON.stringify(formData, null, 2))
  
// fügt in den Cart JS hinzu
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },



  
  body: JSON.stringify(formData)
})
.then(response => {
  return response.json();
})
.catch((error) => {
  console.error('Error:', error);
});

  

 // // console.log("Added");

 
setTimeout(() => {
    window.location.href = 'https://elitescreens.eu/cart';;
}, "1000");



}


/*
function addItems1() {
  formData.items.id = selection.ProdVariant;

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => response.json())
  .then(data => {
    // console.log('Produkt hinzugefügt:', data);

    // Danach die SECTIONS holen
    fetch(window.Shopify.routes.root + '?sections=cart-drawer')
      .then(response => response.json())
      .then(parsedState => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(parsedState); // <== Jetzt parsedState
          } else {
            console.warn('cartDrawer hat keine renderContents-Methode!');
          }

          if (typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        } else {
          console.warn('Kein cart-drawer gefunden!');
        }
      });
  })
  .catch((error) => {
    console.error('Error:', error);
  });

  fetch(window.Shopify.routes.root + '?sections=cart-drawer')
  .then(response => response.json())
  .then(parsedState => {
    // console.log('Sections Response:', parsedState); // <-- hier
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      if (typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(parsedState);
      } else {
        console.warn('cartDrawer hat keine renderContents-Methode!');
      }

      if (typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      }
    } else {
      console.warn('Kein cart-drawer gefunden!');
    }
  });
  
}

/*
function bC(){

  // console.log("BC");
  
  document.dispatchEvent(new CustomEvent('cart:build'));

  document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: {
            product: formData,
            addToCartBtn: this.addToCart
          }
        }));
}
*/





//// Babylon Render Engine 
var slider = document.getElementById("myRange");
var slider2 = document.getElementById("myRange2");

       const sliderheight = document.getElementById("screenheight");
        var sliderheightVal = document.getElementById("screenheightspan");

        var roomnotice = document.getElementById("notice");
        var slidercol3 = document.getElementById("sliderfiller3");


/*var output = document.getElementById("demo");
output.innerHTML = slider.value; // Display the default slider value
*/



var values169;
var values1610;
var values219;
var resFactorX = 1;
var resFactorY = 1;

var leinwandmesh4;
//var shebeammesh;
//var shbeammermesh;


    const button3d = document.getElementById("3db");

if (button3d) {
  button3d.addEventListener("click", showOnly);
}
          
                  document.getElementById("close").addEventListener("click", closeModal);

      const sections = document.querySelectorAll('section');
 var sections1 = document.getElementsByClassName("shopify-section");

  $('.togglebutton').click(function() {
  const $btn = $(this);
  const $panel = $btn.next('.panel'); // nächstes Geschwister-Element
   
  $panel.toggleClass('closed'); // Panel ein-/ausfahren
  $btn.find('.chevron').toggleClass('rotate'); // Chevron drehen
});


function showOnly() {

  for(i=0;i<sections1.length;i++){
    sections1[i].style.display="none";
  }

  // Alle <section>-Elemente ausblenden
  sections.forEach(section => {
    section.style.display = 'none';
  });


  // Das gewünschte Div einblenden
  const selectedDiv = document.getElementById("shopify-section-"+tpn);
  if (selectedDiv) {
    selectedDiv.style.display = 'block'; // Das gewählte Div sichtbar machen
    document.getElementById("3dconfig").style.display="block";
  }

  //newParent.appendChild(priceTags);
  
  startRender();
engine.resize();
  

       //startRender();
         window.scrollTo({
        top: 0,
        behavior: "smooth" // smooth scroll, optional
    });

}

        function closeModal() {
   //

  for(i=0;i<sections1.length;i++){
    sections1[i].style.display="";
  }

  // Alle <section>-Elemente ausblenden
  sections.forEach(section => {
    section.style.display = '';
  });


  // Das gewünschte Div einblenden
  const selectedDiv = document.getElementById("shopify-section-"+tpn);
  if (selectedDiv) {
    selectedDiv.style.display = 'none'; // Das gewählte Div sichtbar machen
    document.getElementById("3dconfig").style.display="none";
  }
          //oldParent.appendChild(priceTags);
        }
      


/*
  // Alle Elemente im body auswählen
  const allDivs = document.querySelectorAll('body > *');

  allDivs.forEach(div => {
    if (div.id !== '3dconfig') {
      div.style.display = 'none'; // Alle ausblenden, außer das mit der ID '3dconfig'
    }
  });

  // Das gewählte Div einblenden
  const selectedDiv = document.getElementById("3dconfig");
  if (selectedDiv) {
    selectedDiv.style.display = 'block'; // Das gewählte Div einblenden
  }*/


  



const canvas = document.getElementById("renderCanvas"); // Get the canvas element
      const engine = new BABYLON.Engine(canvas, true); // Generate the BABYLON 3D engine

engine.setHardwareScalingLevel(1 / window.devicePixelRatio);

      // Add your code here matching the playground format
      const createScene = function () {
        const scene = new BABYLON.Scene(engine);

      const empty = new BABYLON.TransformNode("emptyParent", scene);
        empty.position.y=2.25;
      
    




       
        //const hdrTexture = BABYLON.CubeTexture.CreateFromPrefilteredData("https://assets.babylonjs.com/environments/environmentSpecular.env", scene);
        //scene.environmentTexture = hdrTexture;
        var standardbeambool = false;
        var shortbeambool = false;

        function sleep(ms) {
          return new Promise(resolve => setTimeout(resolve, ms));
        }
   
         values169 = [92,100,110, 120,135,150];
      

        var topDrops=[30,60];

        
        var oldInd=100;
        var newInd=100;

        var nextpos;

        let debounceTimeout;
      
        
        const sliderValue = document.getElementById('sliderLabel');
        const sliderValue2 = document.getElementById('sliderLabel2');
        const sliderValue3 = document.getElementById('sliderLabel3');

     
       
       
       
       


   
       
        var nearestTopDrop = 30;

      
        
     

      

       
var titleRecap;

        function getPrice(){
          var currentId= Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][selection.Size].find(item => item[selection.TopDrop])?.[selection.TopDrop][0];
          selection.ProdVariant=currentId;
           const price = getPriceById(meta, Number(currentId));
           //     // console.log(titleRecap);
           // // console.log(price);
       var   formattedPrice = (price / 100).toLocaleString("de-DE", { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
});
   
         // console.log(formattedPrice);
         pricehtml.innerHTML = "€"+String(formattedPrice)+" EUR";
         confightml.innerHTML= String(titleRecap);
         
checkVariantAvailability(selection.ProdVariant);     
        }
        
        function getPriceById(product, variantId) {
    const variant = product.product.variants.find(v => v.id === variantId);
          titleRecap = variant.public_title
    return variant ? variant.price : null; 
}

   

       var pricehtml = document.getElementById( "pricehtml");
        var confightml = document.getElementById( "confightml");
        
    



        

       

                const tickContainer = document.querySelector('.slider-ticks');


      function getSizes(){

      

        tickContainer.innerHTML = "";
        
        var avSizes = Object.keys(Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor]);
      //  // console.log(selection);
      //  // console.log("avSizes: "+avSizes);
        values169= avSizes;
        //console.log(avSizes);

       //slider2 = document.getElementById("myRange2");
       slider2.min=avSizes[0];
       slider2.max=avSizes[avSizes.length - 1 ]; 

        
       avSizes.forEach(val => {
  const span = document.createElement('span');
  span.textContent = "'";

  // Position in Pixeln berechnen
  const ratio = (val -  slider2.min) / (slider2.max -  slider2.min);
  const posPx = ratio * 346;

  
  span.style.left = `${posPx}px`;

  if(ratio==0){
    span.style.left = `5px`;
  }

  tickContainer.appendChild(span);
});
  

        
       const nearestValue = _.minBy(avSizes, (value) => Math.abs(value - oldInd));
        
       //topDrops = Base.projectorTypes[selection.Beamer][selection.Ambience][selection.Material][selection.Aspect][selection.CaseColor][nearestValue];
        //// console.log(topDrops);
 selection.Size = nearestValue;
newInd = Number(nearestValue);


if(selection.Aspect=="r169"){
 // // console.log("inside ratiuos 169");
       slider2.value=nearestValue;
       sliderValue.innerHTML=nearestValue;

       sliderWidth = slider2.offsetWidth;  // Breite des Sliders
     labelWidth = sliderValue.offsetWidth; // Breite des Labels
     newLeft = ((slider2.value - slider2.min) / (slider2.max - slider2.min)) * sliderWidth - (labelWidth / 2);

     sliderValue.style.left = `${newLeft}px`;

       if(newLeft<=0){
         slidercol.style.width="10px"
                  sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }
        
    // Setze die neue Position des Labels
    
       
        }

  

  
       //oldInd=newInd;
      
       
        //slider2.dispatchEvent(new Event('input'));

        overallScale();

      

      }


     
   


            document.getElementById("r169").addEventListener("click", changeScale169 );

              function changeScale169(){

                resFactorX =1;
                resFactorY = 1;

            //  document.getElementById("res169").style.display="block";
              
           // document.getElementById("res219").style.display="none";
          //    document.getElementById("res1610").style.display="none";
              selection.Aspect="r169";

              $("#r169").prop('disabled', true);
      

                    $("#r169").css({
                      "background-color": "white",
                      "border-color": "#0071e3",
                      "border-width": "2px"
                  });

        

   $('#r219').prop('disabled', false).css({
    "background-color": "",
    "cursor": "",
    "border": ""
})

 $('#r43').prop('disabled', false).css({
  "background-color": "",
    "cursor": "",
    "border": ""
})
      $('#r1610').prop('disabled', false).css({
    "background-color": "",
    "cursor": "",
    "border": ""
})      

            

   

              
              getSizes();
getMaterials();
                overallScale();

                
                  const sliderWidth = slider2.offsetWidth;
           const labelWidth = sliderValue.offsetWidth;

               const newLeft = ((newInd - values169[0]) / ((values169[values169.length - 1]) -values169[0])) * sliderWidth - (labelWidth / 2);
        //// console.log(newLeft);
        slider2.value=newInd;
        sliderValue.innerHTML = newInd;
         sliderValue.style.left =`${newLeft}px`;

           if(newLeft<=0){
         slidercol.style.width="10px"
                  sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }
            
                
              }



                

            document.getElementById("r1610").addEventListener("click", changeScale1610 );

              function changeScale1610(){

                 resFactorX = 0.9729;
                resFactorY = 1.081;

      
         
              selection.Aspect="r1610";

              $("#r1610").prop('disabled', true);
      

                    $("#r1610").css({
                      "background-color": "white",
                      "border-color": "#0071e3",
                      "border-width": "2px"
                  });

        

   $('#r219').prop('disabled', false).css({
    "background-color": "",
    "cursor": "",
    "border": ""
})

 $('#r43').prop('disabled', false).css({
  "background-color": "",
    "cursor": "",
    "border": ""
})
      $('#r169').prop('disabled', false).css({
    "background-color": "",
    "cursor": "",
    "border": ""
})      

            

   

              
              getSizes();
getMaterials();
                overallScale();


                
                  const sliderWidth = slider2.offsetWidth;
           const labelWidth = sliderValue.offsetWidth;

               const newLeft = ((newInd - values169[0]) / ((values169[values169.length - 1]) -values169[0])) * sliderWidth - (labelWidth / 2);
        //// console.log(newLeft);
        slider2.value=newInd;
        sliderValue.innerHTML = newInd;
         sliderValue.style.left =`${newLeft}px`;

           if(newLeft<=0){
         slidercol.style.width="10px"
                  sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }
            
                
              }



               document.getElementById("r219").addEventListener("click",changeScale219);

              function changeScale219(){

                resFactorX = 1.054;
                resFactorY = 0.803;

           // document.getElementById("res169").style.display="none";
             
           //document.getElementById("res1610").style.display="none";
           // document.getElementById("res219").style.display="block";
            selection.Aspect="r219";
             //setwhiteCase()

            $("#r169").prop('disabled', false);
             $("#r43").prop('disabled', false);
            $("#r1610").prop('disabled', false);
            $("#r219").prop('disabled', true);

            $("#r169").css({
              "background-color": "",
              "border-color": "",
              "border-width": ""
          });
              $("#r1610").css({
              "background-color": "",
              "border-color": "",
              "border-width": ""
          });
           $("#r43").css({
              "background-color": "",
              "border-color": "",
              "border-width": ""
          });
          
                  $("#r219").css({
                    "background-color": "white",
                    "border-color": "#0071e3",
                    "border-width": "2px"
                });
/*
                  $('.buttonMat').prop('disabled', true).css({
    "background-color": "grey",
    "cursor": "not-allowed"
});

   $('#CineWhite').prop('disabled', false).css({
    "background-color": "white",
    "cursor": ""
});*/
       
              newInd= 125;
              selection.Size=125;

               getMaterials();
                      
              getSizes();
             overallScale();


                  const sliderWidth = slider2.offsetWidth;
           const labelWidth = sliderValue.offsetWidth;

               const newLeft = ((newInd - values169[0]) / ((values169[values169.length - 1]) -values169[0])) * sliderWidth - (labelWidth / 2);
        //// console.log(newLeft);
        slider2.value=newInd;
        sliderValue.innerHTML = newInd;
         sliderValue.style.left =`${newLeft}px`;

           if(newLeft<=0){
         slidercol.style.width="10px"
                  sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }

              }




              
            document.getElementById("r43").addEventListener("click", changeScale43);

              function changeScale43(){

                 resFactorX = 0.918;
                resFactorY = 1.225;

      
         
              selection.Aspect="r43";

              $("#r43").prop('disabled', true);
      

                    $("#r43").css({
                      "background-color": "white",
                      "border-color": "#0071e3",
                      "border-width": "2px"
                  });

        

   $('#r219').prop('disabled', false).css({
    "background-color": "",
    "cursor": "",
    "border": ""
})

 $('#r1610').prop('disabled', false).css({
  "background-color": "",
    "cursor": "",
    "border": ""
})
      $('#r169').prop('disabled', false).css({
    "background-color": "",
    "cursor": "",
    "border": ""
})      

            

   

              
              getSizes();
getMaterials();
                overallScale();


                
                  const sliderWidth = slider2.offsetWidth;
           const labelWidth = sliderValue.offsetWidth;

               const newLeft = ((newInd - values169[0]) / ((values169[values169.length - 1]) -values169[0])) * sliderWidth - (labelWidth / 2);
        //// console.log(newLeft);
        slider2.value=newInd;
        sliderValue.innerHTML = newInd;
         sliderValue.style.left =`${newLeft}px`;

           if(newLeft<=0){
         slidercol.style.width="10px"
                  sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }
            
                
              }



               document.getElementById("r219").addEventListener("click",changeScale219);

              function changeScale219(){

                resFactorX = 1.054;
                resFactorY = 0.803;

           // document.getElementById("res169").style.display="none";
             
           //document.getElementById("res1610").style.display="none";
           // document.getElementById("res219").style.display="block";
            selection.Aspect="r219";
             //setwhiteCase()

            $("#r169").prop('disabled', false);
             $("#r43").prop('disabled', false);
            $("#r1610").prop('disabled', false);
            $("#r219").prop('disabled', true);

            $("#r169").css({
              "background-color": "",
              "border-color": "",
              "border-width": ""
          });
              $("#r1610").css({
              "background-color": "",
              "border-color": "",
              "border-width": ""
          });
           $("#r43").css({
              "background-color": "",
              "border-color": "",
              "border-width": ""
          });
          
                  $("#r219").css({
                    "background-color": "white",
                    "border-color": "#0071e3",
                    "border-width": "2px"
                });
/*
                  $('.buttonMat').prop('disabled', true).css({
    "background-color": "grey",
    "cursor": "not-allowed"
});

   $('#CineWhite').prop('disabled', false).css({
    "background-color": "white",
    "cursor": ""
});*/
       
              newInd= 125;
              selection.Size=125;

               getMaterials();
                      
              getSizes();
             overallScale();


                  const sliderWidth = slider2.offsetWidth;
           const labelWidth = sliderValue.offsetWidth;

               const newLeft = ((newInd - values169[0]) / ((values169[values169.length - 1]) -values169[0])) * sliderWidth - (labelWidth / 2);
        //// console.log(newLeft);
        slider2.value=newInd;
        sliderValue.innerHTML = newInd;
         sliderValue.style.left =`${newLeft}px`;

           if(newLeft<=0){
         slidercol.style.width="10px"
                  sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }

              }



              


  
              async function overallScale(){

 if(oldInd <= newInd){
              for (let i = oldInd; i <= newInd; i++) {   
              
              leinwandmesh1.scaling = new BABYLON.Vector3((resFactorX*i/84),(resFactorY*i)/84,1);

              RahmenL.position.x = -(0.0127*breiteX*(i*resFactorX)+0.028);
              RahmenR.position.x = (0.0127*breiteX*(i*resFactorX)+0.028);  
              
              lrscale = (((104.656*((i*resFactorY)/84))+(6.032*2))/(116.6)).toFixed(3);

              RahmenL.scaling = new BABYLON.Vector3(1,lrscale,1);  
              RahmenR.scaling= new BABYLON.Vector3(1,lrscale,1);  
              
             
           
              RahmenU.position.y =  -(((resFactorY*i)-84)*0.01247)-0.583;
              
              RahmenO.scaling = new BABYLON.Vector3((resFactorX*i/84),1,1);
              RahmenU.scaling= new BABYLON.Vector3((resFactorX*i/84),1,1);

             

           
              Logo.position.x=(0.856+((i*resFactorX)-84)*0.0112);
              Logo.position.y=RahmenU.position.y-0.552;

          //leinwandmesh.rotation = new BABYLON.Vector3(0,3.14,0);



                      await sleep(30);       
            }}else if(oldInd > newInd){   
            
              for (let i = oldInd; i > newInd; i--) {                                                      
                  leinwandmesh1.scaling = new BABYLON.Vector3((resFactorX*i/84),(resFactorY*i)/84,1);

              RahmenL.position.x = -(0.0127*breiteX*(i*resFactorX)+0.028);
              RahmenR.position.x = (0.0127*breiteX*(i*resFactorX)+0.028);  
              
              lrscale = (((104.656*((i*resFactorY)/84))+(6.032*2))/(116.6)).toFixed(3);

              RahmenL.scaling = new BABYLON.Vector3(1,lrscale,1);  
              RahmenR.scaling= new BABYLON.Vector3(1,lrscale,1);  
              
             
           
              RahmenU.position.y =  -(((resFactorY*i)-84)*0.01247)-0.583;
              
              RahmenO.scaling = new BABYLON.Vector3((resFactorX*i/84),1,1);
              RahmenU.scaling= new BABYLON.Vector3((resFactorX*i/84),1,1);

             

           
              Logo.position.x=(0.856+((i*resFactorX)-84)*0.0112);
              Logo.position.y=RahmenU.position.y-0.552;
             await sleep(30);       
            
            }

           
            }
       

            oldInd=newInd;
            //// console.log("post scale169: " +"oldInd:"+oldInd+"newInd: "+newInd);
            //checkColorAv();

               
            if(roombool){

            
           if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
          else if(selection.Aspect==="r1610"){
            checkSize(newInd,16,10);
          }else if(selection.Aspect==="r219"){
checkSize(newInd,21,9);
          }else if(selection.Aspect==="r43"){
checkSize(newInd,4,3);
          }
       
        

        //  // console.log("HÖHE:" + (gesamthöhe) + "Breite: " + screenwidth)
          if(gesamthöhe>roomHeight.value ){
          //    // console.log("CLIP HEIGHT");
          } 
            if(screenwidth > roomWidth.value){
            //// console.log("WIDTH HEIGHT");
          }

          //vom Boden
          if((empty.position.y-(gesamthöhe*0.01))<0){
              //// console.log("CLIP CHANGE SLIDERVAL");
              empty.position.y = 0.01*(gesamthöhe+10);
               screenheightgui(gesamthöhe+10);
             // // console.log("HERESLIDERHEIGHT" + sliderheight.value);
            }
            
            // Positioniere LW immer an oberster position 
            if((empty.position.y+20>(roomHeight.value*0.01))){
              //// console.log("ZU GROß MACH KLEIN");
              empty.position.y = 0.01*(roomHeight.value-20);
              screenheightgui(roomHeight.value-20);
              //// console.log("HERESLIDERHEIGHT" + sliderheight.value);
            }
        
              checkScreensize();
          }
              getPrice();

              }

      


        

  


          //Gehäuse
           var gehäusemesh = BABYLON.AbstractMesh;
          var leinwandmesh = BABYLON.AbstractMesh;
          var leinwandmesh1 = BABYLON.AbstractMesh;
       

          var RahmenL;
          var RahmenR;
          var RahmenO;
          var RahmenU;
          var Rückseite;
         
          var Logo;

     

https://cdn.shopify.com/3d/models/a5ded2ceed87d663/EZ_Frame_3D_Configurator_2.glb
        
        leinwandtuch = BABYLON.SceneLoader.ImportMesh("", "https://cdn.shopify.com/3d/models/a5ded2ceed87d663/", "EZ_Frame_3D_Configurator_2.glb", scene, function(newMeshes){
            leinwandmesh= newMeshes[0];
           //leinwandmesh1= newMeshes[19];

           leinwandmesh1= scene.getTransformNodeByName("Plane");


           /*leinwandmesh2= newMeshes[3];
           leinwandmesh4= newMeshes[1];
          leinwandmesh5= newMeshes[0];
            gehäusemesh= newMeshes[0];*/
            
             /* gehäusemesh.setParent(empty);
            leinwandmesh.setParent(empty);
           leinwandmesh1.setParent(empty);
           leinwandmesh2.setParent(empty);
          leinwandmesh4.setParent(empty);*/

          //leinwandmesh4.scaling.y = 1;
          //leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
       //   // console.log(leinwandmesh4.position.y);


                    RahmenL = scene.getMeshByName("Rahmen-L"); // Beispielname fuer Sitzelement
                    RahmenR = scene.getMeshByName("Rahmen-R"); // Beispielname fuer Sitzelement
                    RahmenO = scene.getMeshByName("Rahmen-O");
                    RahmenU = scene.getMeshByName("Rahmen-U");
                    //Rückseite = scene.getTransformNodeByName("Rückseite-LW.001");

                    

                    Logo = scene.getTransformNodeByName("Logo Silver");

                    leinwandmesh.setParent(empty, true);

               

         document.querySelectorAll(".buttonMat").forEach(btn => btn.addEventListener("click", changeMat));


          function changeMat(){
         //   // console.log("click");

            BABYLON.GLTF2.Loader.Extensions.KHR_materials_variants.SelectVariant(leinwandmesh,$(this).attr("id"));
            selection.Material=$(this).attr("id");
            if(selection.Material=="CLR"){
            
            }

          
           
        document.querySelectorAll(".buttonMat").forEach(btn => btn.disabled = false);

        $(this).prop('disabled', true);
        
        document.querySelectorAll(".buttonMat").forEach(btn => {
  btn.style.backgroundColor = "";
  btn.style.borderColor = "";
  btn.style.borderWidth = "";
});
        $(this).css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });

     
           
            getRatios();
            getMaterials();
           
         //   // console.log("before getsizes");
            getSizes();    
          //  // console.log("after getsizes");
        
            
     
            
         

            
      
    
          


         //   // console.log(selection);
          }

          overallScale();
       });
          

       var i;


         function screenheightgui(v){


        const newLeft4 = parseInt(((v - sliderheight.min) /(sliderheight.max - sliderheight.min))*300) ;
        slidercol3.style.width=`${newLeft4}px`;
          sliderheightVal.style.left =`${newLeft4}px`;
          sliderheightVal.innerHTML=v;

       }

        sliderheight.oninput = function(){
        //  // console.log("slider");
          empty.position.y= (0.01*(sliderheight.value)); //.8

    
        sliderheightVal.innerHTML= parseInt(sliderheight.value) ;
        screenheightgui(sliderheight.value);

         
        }

              var slidercol = document.getElementById("sliderfiller");
        var slidercol2 = document.getElementById("sliderfiller2");
       var slidercol4 = document.getElementById("sliderfiller4");

       var breiteX= (16 / Math.sqrt(16**2 + 9**2));

       var hoheY = (9 / Math.sqrt(16**2 + 9**2));


            



       slider2.oninput = function() {
         i = Number(slider2.value);
         sliderValue.innerHTML = i;
         
         oldInd= i;
     
     //   // console.log("I: "+i);

         const sliderWidth = this.offsetWidth;
           const labelWidth = sliderValue.offsetWidth;
           const newLeft = ((i - this.min) / (this.max - this.min)) * sliderWidth - (labelWidth / 2);
           //// console.log(newLeft);

           sliderValue.style.left =`${newLeft}px`;

          if(newLeft<=0){
         slidercol.style.width="10px"
                  sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }

           gehäusemesh.rotation = new BABYLON.Vector3(0, 0, 0);
        
                      leinwandmesh1.scaling = new BABYLON.Vector3((resFactorX*i/84),(resFactorY*i)/84,1);

              RahmenL.position.x = -(0.0127*breiteX*(i*resFactorX)+0.028);
              RahmenR.position.x = (0.0127*breiteX*(i*resFactorX)+0.028);  
              
              lrscale = (((104.656*((i*resFactorY)/84))+(6.032*2))/(116.6)).toFixed(3);

              RahmenL.scaling = new BABYLON.Vector3(1,lrscale,1);  
              RahmenR.scaling= new BABYLON.Vector3(1,lrscale,1);  
              
             
           
              RahmenU.position.y =  -(((resFactorY*i)-84)*0.01247)-0.583;
              
              RahmenO.scaling = new BABYLON.Vector3((resFactorX*i/84),1,1);
              RahmenU.scaling= new BABYLON.Vector3((resFactorX*i/84),1,1);

             

           
              Logo.position.x=(0.856+((i*resFactorX)-84)*0.0112);
              Logo.position.y=RahmenU.position.y-0.552;


               //leinwandmesh2.scaling = new BABYLON.Vector3(i/100,i/100,1);
               //leinwandmesh4.scaling = new BABYLON.Vector3(i/100,i/100,1);


         //leinwandmesh.rotation = new BABYLON.Vector3(0,3.14,0);
              
               //leinwandmesh2.rotation = new BABYLON.Vector3(0, 0, 0);
              //leinwandmesh4.rotation = new BABYLON.Vector3(0, 0, 0);
              //leinwandmesh5.rotation = new BABYLON.Vector3(0, 0, 0);
         
               



         
               
              

            
             
                
               const nearestValue = _.minBy(values169, (value) => Math.abs(value - i));
            //   // console.log(values169);
            //   // console.log(i);
       newInd= nearestValue;
         selection.Size = nearestValue;
      //  // console.log("nearesT: "+ nearestValue);

 
               //oldInd = i;
               //sliderValue.innerHTML = newInd;
               
       clearTimeout(debounceTimeout);
       debounceTimeout = setTimeout( function() {
         
         
         
         const newLeft = ((newInd - values169[0]) / ((values169[values169.length - 1]) -values169[0])) * sliderWidth - (labelWidth / 2);
        //// console.log(newLeft);
        slider2.value=newInd;
        sliderValue.innerHTML = newInd;
         sliderValue.style.left =`${newLeft}px`;

           if(newLeft<=0){
         slidercol.style.width="10px"
                  sliderValue.style.left =`-4px`;

         }else{
          slidercol.style.width=`${newLeft}px`;
         }

         //// console.log("SLIDER 2 ");
         //// console.log("Slidertest "+"Nearest:"+nearestValue+"oldInd"+oldInd+"newInd"+newInd);
        
         
         //scale169();
        overallScale();
        
         
         
  
         
         
         

     }, 100); // Verzögerung von 300ms //
               
    

     }

       
      

       
     
      
      

        const camera = new BABYLON.ArcRotateCamera("camera", -Math.PI / 2, Math.PI / 2.5, 15, new BABYLON.Vector3(0, 0, 0));
        camera.attachControl(canvas, true);
        camera.setPosition(new BABYLON.Vector3(0, -0.5,4));
        camera.target = new BABYLON.Vector3(0 ,-0.75,0);
        const light = new BABYLON.HemisphericLight("light", new BABYLON.Vector3(0, 1, 1));

         const pointLight = new BABYLON.PointLight("point", new BABYLON.Vector3(0, 0, -5), scene);
        pointLight.intensity = 0.4;
        
      
        camera.wheelPrecision = 70;
        camera.lowerRadiusLimit=1;
        camera.minZ = 0;

       var bGchange = document.getElementById("mainelement");

        
      // Füge die Animation der Kamera hinzu
      document.getElementById("Dark").addEventListener("click",async () => {


      
        $("#Dark").prop('disabled', true);
        $("#Bright").prop('disabled', false);

        $("#Bright").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });

        $("#Dark").css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });
       
   

        for(let i=1; i< 25; i++){
          var cVal = 100-i;
          scene.clearColor = new BABYLON.Color4(cVal/100, cVal/100, cVal/100, 1);
          bGchange.style.background = "rgb(" + cVal + "% " + cVal + "% " + cVal + "%)";

           if(roombool){
          wallMaterial.specularPower = 2.56*i;
          } 
          pointLight.intensity = 0.4-(0.016*i); 
          
          await sleep(10); 

        }



      });

      document.getElementById("Bright").addEventListener("click",async () => {

      //var buttony=  // console.log(Base[selection.Beamer][selection.Ambiance][0])



      if(avMaterials.length > 0){
        console.log("avbigger");
        const event = new Event("click", { bubbles: true, cancelable: true });
        document.getElementById(avMaterials[0]).dispatchEvent(event);
         document.getElementById(avRatios[0]).dispatchEvent(event);
         //console.log(avRatios);
}

        $("#Bright").prop('disabled', true);
        $("#Dark").prop('disabled', false);


        $("#Dark").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });

        $("#Bright").css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });

        

    

        for(let i=1; i< 25; i++){
          var cVal2 = 75+i
          scene.clearColor = new BABYLON.Color4(cVal2/100, cVal2/100, cVal2/100, 1);         
          bGchange.style.background = "rgb(" + cVal2 + "% " + cVal2 + "% " + cVal2 + "%)";
          if(roombool){
            wallMaterial.specularPower = 64-(2.56*i);
                    }
          pointLight.intensity = 0.016*i;
          await sleep(10); 

        }

      });
     
     /* document.getElementById("removebeamer").addEventListener("click",removeB);

      function removeB(){
        camera.setPosition(new BABYLON.Vector3(0, -1,4));
        camera.target = new BABYLON.Vector3(0 ,-0.5,0);
        if(shortbeambool){
          shbeamermesh.dispose();
        shbeammesh.dispose();
        shortbeambool = false;
        }else if(standardbeambool){
          if(standardbeambool){
            stbeamermesh.dispose();
          stbeammesh.dispose();
          standarbeambool = false;
          }
        }
      } */

        //Beamer
       document.getElementById("Standard-Throw").addEventListener("click",selectStandardBeamer);

       function selectStandardBeamer(){

       selection.Beamer= $(this).attr("id");
        console.log($(this).attr("id"));
      

       
        $("#Standard-Throw").prop('disabled', true);
        $("#Short-Throw").prop('disabled', false);
        
        $("#Short-Throw").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });

        $(this).css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });
        
        

        
    //    // console.log(selection.Beamer);
        getMaterials();
        
       if( avMaterials.length > 0){
      const event = new Event("click", { bubbles: true, cancelable: true });
        document.getElementById(avMaterials[0]).dispatchEvent(event);
          
       }
      /*  if(shortbeambool){
          shbeamermesh.dispose();
        shbeammesh.dispose();
        }
*/
        standardbeambool = true;
        shortbeambool = false;

        //changeScale169();

       }

           document.getElementById("Short-Throw").addEventListener("click",selectShortBeamer);

       function selectShortBeamer(){
       
       selection.Beamer= $(this).attr("id");
       
     

       
        $("#Standard-Throw").prop('disabled', false);
        $("#Short-Throw").prop('disabled', true);
        
        $("#Standard-Throw").css({
          "background-color": "",
          "border-color": "",
          "border-width": ""
      });

        $(this).css({
          "background-color": "white",
          "border-color": "#0071e3",
          "border-width": "2px"
      });

        
    //    // console.log(selection.Beamer);
        getMaterials();
           if( avMaterials.length > 0){
      const event = new Event("click", { bubbles: true, cancelable: true });
        document.getElementById(avMaterials[0]).dispatchEvent(event);
          
           }
      /*  if(shortbeambool){
          shbeamermesh.dispose();
        shbeammesh.dispose();
        }
*/
        standardbeambool = false;
        shortbeambool = true;

        //changeScale169();

       }
      



      //ROOMSTART

        //getSizes();
  //ROOM

          var mainWall; 
    var roombool;
         var wallMaterial;

    function createRoom(){
         $('#roomgui').addClass('panel');
          $('#roomgui').removeClass('roomguic');
 document.getElementById("createRoom").style.display="none";
      
      roombool=true;
        if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
          else if(selection.Aspect==="r1610"){
            checkSize(newInd,16,10);
          }else if(selection.Aspect==="r219"){
checkSize(newInd,21,9);
          }else if(selection.Aspect==="r43"){
checkSize(newInd,4,3);
          }
       
       
          

        wallMaterial = new BABYLON.StandardMaterial("wallMat", scene);
        wallMaterial.diffuseColor = new BABYLON.Color3(1, 1, 1);
        wallMaterial.roughness=0;
        wallMaterial.specularColor = new BABYLON.Color3(0.1, 0.1, 0.1); // weniger Glanz
        
      if(selection.Ambience=="Dark"){wallMaterial.specularPower = 64;}else{
        wallMaterial.specularPower = 0;
      } // glatterer Glanzpunkt

        const floorMaterial = new BABYLON.StandardMaterial("floorMat", scene);
        var  texture = new BABYLON.Texture("https://cdn.shopify.com/s/files/1/0568/2806/8035/files/floor.webp?v=1752150856", scene);

        floorMaterial.diffuseTexture =  texture;
        //floorMaterial.specularColor = new BABYLON.Color3(0.1, 0.1, 0.1);

      

        // Maße
        var wallWidth = 0.01*(screenwidth+150);
    //    // console.log(wallWidth);
        var wallHeight = 0.01*(gesamthöhe+150);
        var wallDepth = 0.01;


        // Setze interface mit beschränkungen
          roomHeight.value=parseInt(gesamthöhe)+150;
          roomWidth.value=parseInt(screenwidth)+150;
        //

        var floorWidth = wallWidth;
        var floorLength = wallWidth + wallDepth;
        // Hauptwand (Front)
         mainWall = BABYLON.MeshBuilder.CreateBox("mainWall", {
            width: 1,
            height: 1,
            depth: 0.01
        }, scene);
        //mainWall.position = new BABYLON.Vector3(0, -3, 0);
        mainWall.material = wallMaterial;
        mainWall.setPivotPoint(new BABYLON.Vector3(0, -1 / 2, 0));

        // Linke Wand
        const leftWall = BABYLON.MeshBuilder.CreatePlane("floor", {width: 1, height: 1}, scene);

        leftWall.rotation.y = 1.5*Math.PI;
        // position x = -halbe Wandbreite, z = -halbe Wandbreite (links hinten)
        leftWall.position = new BABYLON.Vector3(-1 / 2, 0, -1 / 2);
        leftWall.material = wallMaterial;

        // Rechte Wand
        const rightWall = BABYLON.MeshBuilder.CreatePlane("floor", {width: 1, height: 1}, scene);
        rightWall.rotation.y = Math.PI / 2;
        // position x = +halbe Wandbreite, z = -halbe Wandbreite (rechts hinten)
        rightWall.position = new BABYLON.Vector3(1 / 2, 0, -1 / 2);
        rightWall.material = wallMaterial;

        // Boden als Plane genau passend in den Raum
        // Breite = wallWidth (zwischen linken und rechten Wand-Innenkanten)
        // Länge = wallWidth + Wanddicke (von Frontwand bis Rückseite der Seitenwände)
        // etwas tiefer als Seitenwand Tiefe

        const floor = BABYLON.MeshBuilder.CreatePlane("floor", {width: 1, height: 1}, scene);
        floor.rotation.x = Math.PI / 2; // flach auf Boden
        // positioniert unterhalb der Wände:
        // Y = 0 (Boden)
        // Z = -(floorLength / 2) + Wanddicke/2 (damit es unter Frontwand und zwischen Seitenwänden liegt)
        floor.position = new BABYLON.Vector3(0, -1/2, -1.01 / 2 + 0.01 / 2);
        floor.material = floorMaterial;

        // Parenting
        leftWall.parent = mainWall;
        rightWall.parent = mainWall;
        floor.parent = mainWall;

        
        mainWall.rotation.y=Math.PI;
        mainWall.position.y=-1.75;
        mainWall.position.z=-0.065;

        mainWall.scaling.x=wallWidth;
        mainWall.scaling.y=wallHeight;
         mainWall.scaling.z=3;

      sliderheight.min = gesamthöhe+20;
      sliderheight.max= (100*wallHeight)-20;

        
            if((empty.position.y-((gesamthöhe+5)*0.01))<0){
          //    // console.log("CLIP");
              empty.position.y = 0.01*(gesamthöhe+20);
              screenheightgui(gesamthöhe+20);
            }
          

     }
    
    

//createRoom();
        //Skaliere Raum:
       // // console.log("TEST");
        document.getElementById("createRoom").addEventListener("click",createRoom);
    //WAND ENDE


    document.getElementById("removeRoom").addEventListener("click",deleteRoom);

    function deleteRoom(){
       roombool=false; 
          mainWall.dispose();
           $('#roomgui').removeClass('panel');
          $('#roomgui').addClass('roomguic');
       document.getElementById("createRoom").style.display="flex";
    }

    document.getElementById("updateRoom").addEventListener("click",updateRoom );

      
     const roomHeight = document.getElementById("roomheight");
  const roomWidth = document.getElementById("roomwidth");

    function updateRoom(){
       
  const roomHeightval =roomHeight.value;
  const roomWidthval = roomWidth.value

     // // console.log(roomWidthval/screenwidth+100);
          //mainWall.scaling.y = (0.01*roomHeightval)/2.4
 if (
  !isNaN(roomHeightval)
 && roomHeightval >= 220 && roomHeightval <= 600 
 
) {
  mainWall.scaling.y = roomHeightval/100;
//  // console.log("Raumhöhe:", roomHeightval, "cm");

   sliderheight.max= roomHeightval-20;

 // wenn gesamtgröße >als wand dann färbe leinwand rot, wenn gesamtgröße < wand dann platziere ganz oben
 //// console.log("G"+gesamthöhe + "roomheight "+ roomHeightval);

   if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
          else if(selection.Aspect==="r1610"){
            checkSize(newInd,16,10);
          }else if(selection.Aspect==="r219"){
checkSize(newInd,21,9);
          }else if(selection.Aspect==="r43"){
checkSize(newInd,4,3);
          }
       

 if((parseInt(empty.position.y*100))>roomHeightval){
  //// console.log("clipeprcheck");
    empty.position.y=(sliderheight.max/100);
    screenheightgui(sliderheight.max);
    /*sliderheightVal.innerHTML=sliderheight.max;
    sliderheight.value=sliderheight.max; */
 }else{
 
screenheightgui(parseInt(empty.position.y*100));
 }
  
}else{
  
  alert("Please enter a wall height between 220 cm and 600 cm");

}

 if(!isNaN(roomWidthval) &&  roomWidthval >= 240 && roomWidthval <= 1000){
  mainWall.scaling.x = roomWidthval/100;
  //// console.log("Raumhöhe:", roomHeightval, "cm");

   sliderheight.max= roomHeightval-20;

 // wenn gesamtgröße >als wand dann färbe leinwand rot, wenn gesamtgröße < wand dann platziere ganz oben
 //// console.log("G"+gesamthöhe + "roomheight "+ roomHeightval);

   if(selection.Aspect==="r169"){
          checkSize(newInd,16,9);}
          else if(selection.Aspect==="r1610"){
            checkSize(newInd,16,10);
          }else if(selection.Aspect==="r219"){
checkSize(newInd,21,9);
          }else if(selection.Aspect==="r43"){
checkSize(newInd,4,3);
          }
         

 if((parseInt(empty.position.y*100))>roomHeightval){
  
  //// console.log("clipeprcheck");
    empty.position.y=(sliderheight.max/100);
    screenheightgui(sliderheight.max);
    /*sliderheightVal.innerHTML=sliderheight.max;
    sliderheight.value=sliderheight.max; */
 }else{
 
screenheightgui(parseInt(empty.position.y*100));
 }

 }else{ alert("Please enter a wall width between 240 cm and 1000 cm");}

 
checkScreensize();
 
    }


    var gesamthöhe;
    var screenwidth;

    
      function checkSize(diagonalInInches, ratioWidth, ratioHeight){

    //  // console.log("CHECKSIZE  ")
       var  screenframe=12;
        var factor = Math.sqrt(ratioWidth ** 2 + ratioHeight ** 2);

        


        //var widthInInches = diagonalInInches * (ratioWidth / factor);
        var heightInInches = diagonalInInches * (ratioHeight / factor);
       // // console.log("height" + heightInInches);
        
        //  ALTE FORMEL: screenwidth = 264* (diagonalInInches/100); => die 264 sind vom saker wegen der case, die über die leinwand hinausgeht.
        screenwidth = (186+screenframe)* (diagonalInInches/84)*resFactorX;
         //   // console.log("width" + screenwidth);
        var screenheight = heightInInches * 2.54*resFactorX;
       // // console.log("cm heigth" + screenheight);

         gesamthöhe = parseInt(screenheight+screenframe);
       // // console.log("Berechnung: height"+ screenheight );

        //sliderheight.max=gesamthöhe+80;
        sliderheight.min = gesamthöhe+10;

       
        // -> if 

        //// console.log("Breite: "+ screenwidth);
        //// console.log("Höhe: "+ gesamthöhe );

        //sliderheight.max= gesamthöhe+80;

      }


      //document.getElementById("checksizing").addEventListener("click",checkSize(newInd,16,9));

      
      function checkScreensize(){
// console.log("SCREENSIZE"),
//// console.log("Zu Hoch. LW "+gesamthöhe +" Raum:  " +roomHeight.value )
// // console.log("Zu Breit. LW "+screenwidth +" Raum:  " +roomWidth.value )
roomnotice.style.display="none";


if(gesamthöhe+20>roomHeight.value){
  // console.log("Zu Hoch. LW "+gesamthöhe +" Raum:  " +roomHeight.value )
  roomnotice.style.display="flex";
}

if(screenwidth>roomWidth.value){
 // console.log("Zu Breit. LW "+screenwidth +" Raum:  " +roomWidth.value )
  roomnotice.style.display="flex";
}
      }


         // ROOMEND

    
      //  scene.debugLayer.show();
        return scene;
      };

      
    
      function startRender(){
      const scene = createScene(); //Call the createScene function
      scene.clearColor = new BABYLON.Color4(0.75, 0.75, 0.75, 1);
      //engine.resize();

      // Register a render loop to repeatedly render the scene
      engine.runRenderLoop(function () {
        scene.render();
      });

      // Watch for browser/canvas resize events
      window.addEventListener("resize", function () {
        engine.resize();
      })
    }

var butAddC = document.getElementById("addCart");
      
            function checkVariantAvailability(variantId) {
  fetch(`/variants/${variantId}.js`)
    .then(res => res.json())
    .then(variant => {
      if (variant.available) {
        // console.log('Variante verfügbar ✅');
        butAddC.innerHTML="Add to cart"
        butAddC.classList.remove('disabled');
        butAddC.disabled=false;
        // Hier Button aktivieren
        //document.querySelector('#add-to-cart-button').disabled = false;
      } else {
        // console.log('Variante NICHT verfügbar ❌');
        butAddC.innerHTML="Sold out"
       butAddC.disabled=true;
        butAddC.classList.add('disabled');
        // Hier Button deaktivieren
        //document.querySelector('#add-to-cart-button').disabled = true;
      }
    })
    .catch(err => {
      console.error('Fehler beim Prüfen der Variante:', err);
    });
}


  //startRender();
    

      startRender();
    

      document.getElementById("canvas-style").addEventListener("click", startEngine, { once: true })
  document.getElementById("canvas-style").addEventListener("touchstart",startEngine, { once: true });
    
  function startEngine(){
document.getElementById("poster").style.display="none";
  }

    function setGrey(){

           $('.buttonMat').prop('disabled', true).css({
    "background-color": "grey",
    "cursor": "not-allowed"
});

  }